var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElementor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 123.305 595.279 595.281",
    enableBackground: "new 0 123.305 595.279 595.281",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.6614,
    y1: 755.645,
    x2: -13.6614,
    y2: 756.645,
    gradientTransform: "matrix(595.2751 0 0 595.2777 8131.8652 -449695.9063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED345E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#382C74"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "url(#Shape_1_)",
    d: "M565.516,123.305H29.764C13.607,123.305,0,136.911,0,153.069v535.753 c0,16.156,13.606,29.764,29.764,29.764h535.752c16.158,0,29.764-13.607,29.764-29.764V153.069 C595.28,136.911,581.674,123.305,565.516,123.305L565.516,123.305z M218.553,552.757h-52.725V289.133h52.725V552.757z M430.302,552.757H271.278v-52.725h159.024V552.757z M430.302,447.308H271.278v-52.726h159.024V447.308z M430.302,341.858H271.278 v-52.725h159.024V341.858z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementor);
export default __webpack_public_path__ + "static/media/elementor.944648a4e02508b8828d1f7e291b4550.svg";
export { ForwardRef as ReactComponent };